import TeamStatistics from 'components/general/TeamStatistics'

function HbbTeamStats({ data }) {

  const stats = [
    { code: 'POINTS'},
    { code: 'DDD'},
    { code: 'DDISQ'},
    { code: 'DISQ'},
    { code: 'SUS'},
    { code: 'PEN' , component:'type7'},
    { code: '1P' , component:'type7'},
    { code: 'OSG' , component:'type7'},
    { code: 'SDG' , component:'type7'},
    { code: 'SPE' , component:'type7'},
    { code: 'SPN' , component:'type7'},
    { code: 'INF' , component:'type7'},
    { code: 'SHOT%' , paint: 'SHOT' , component:'type8'},  //%
    { code: 'SHOT' , component:'type7' } //GS
  ]

  return (<>
    <TeamStatistics data={data?.results} stats={stats} />
  </>);
}


export default HbbTeamStats;